'use strict';

var _ = require('lodash');
var SnapshotDatesChartDataService = function SnapshotDatesChartDataService(pricingSummaryCommonsDataService, heatMapService, pricingDateChartGapsService) {
  function retrieveData() {
    return pricingSummaryCommonsDataService.getSummaryData();
  }
  function aggregate(dataGrouped) {
    var basic = {
      snapshotDate: dataGrouped[0].optimizationDate,
      runNumber: dataGrouped[0].runNumber,
      effectedServices: [],
      excludedServices: [],
      extendedServices: [],
      recommendations: 0,
      totalFareChange: [],
      selected: true,
      isGap: false,
      markets: [],
      cabins: [],
      poses: [],
      direction: dataGrouped[0].direction
    };
    return _.reduce(dataGrouped, function (result, value) {
      result.effectedServices.push(value.numberOfEffectedServices);
      result.excludedServices.push(value.numberOfExcludedServices);
      result.extendedServices.push(value.numberOfExtendedServices);
      result.totalFareChange.push(value.totalFareChange);
      result.markets.push(value.market);
      result.cabins.push(value.cabin);
      result.poses.push(value.pos);
      return result;
    }, basic);
  }
  function prepareChartData(chartObj) {
    var selectedMetric = heatMapService.getCurrentMetric();
    chartObj.metrics = {
      avgFareChange: _.round(_.sum(chartObj.totalFareChange) / _.sum(chartObj.effectedServices) || 0),
      totalFareChange: _.round(_.sum(chartObj.totalFareChange) || 0)
    };
    chartObj.markets = _.uniq(chartObj.markets);
    chartObj.cabins = _.uniq(chartObj.cabins);
    chartObj.poses = _.uniq(chartObj.poses);
    chartObj.effectedServices = _.sum(chartObj.effectedServices);
    chartObj.excludedServices = _.sum(chartObj.excludedServices);
    chartObj.extendedServices = _.sum(chartObj.extendedServices);
    chartObj.m1 = chartObj.metrics[selectedMetric] || 0;
    chartObj.circles = [{
      value: chartObj.effectedServices,
      css: 'm3-circle'
    }, {
      value: chartObj.excludedServices,
      css: 'm4-circle'
    }];
    delete chartObj.groupedAvgFareChangeSum;
    delete chartObj.totalFareChange;
    return chartObj;
  }
  function aggregateToChartData(data) {
    var chartData = _.chain(data).groupBy(function (dataElement) {
      return dataElement.optimizationDate + '-' + dataElement.runNumber;
    }).map(function (flattenedDataGrouped) {
      var chartObj = aggregate(flattenedDataGrouped);
      return prepareChartData(chartObj);
    }).sortBy(function (dataElement) {
      return parseInt(dataElement.runNumber);
    }).value();
    return pricingDateChartGapsService.fillGaps(chartData, 'snapshotDate');
  }
  function getData() {
    return retrieveData().then(aggregateToChartData);
  }
  return {
    getData: getData
  };
};
SnapshotDatesChartDataService.$inject = ['PricingSummaryCommonsDataService', 'FareChangeGridMetricHeatmapService', 'PricingDateChartGapsService'];
module.exports = SnapshotDatesChartDataService;